module.exports = __webpack_public_path__ + "img/home_lijichadan.801fa1a.webp";